import { render, staticRenderFns } from "./TaxSummary.vue?vue&type=template&id=dff4c924&scoped=true"
import script from "./TaxSummary.vue?vue&type=script&lang=js"
export * from "./TaxSummary.vue?vue&type=script&lang=js"
import style0 from "./TaxSummary.vue?vue&type=style&index=0&id=dff4c924&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff4c924",
  null
  
)

export default component.exports